module.exports = __webpack_public_path__ + "img/logo_pc.d70a5565.svg";